import { Link } from 'react-router-dom'
import Breadcrumb from "../Component/Breadcrumb"
import Footer from "../Component/Footer"
import Header from "../Component/Header"
import Menu from "../Component/Menu"
import PageTitle from "../Component/PageTitle"

const WallOfFame = () => {
    const homeMenu = [
        { label: "Admission Notification ", link: "/howtoapply" },
        { label: "Fee Structure", link: "/feestructure" },
        { label: "Prospectus ", link: "/Prospectus" },
        { label: "Virtual School Tour ", link: "https://iviewd.com/lotus_valley_gurgaon/" },
        { label: "School Schedule ", link: "/schoolSchedule" },
        {
            label: "Transport", link: "", subMenu: [
                { label: "Transport", link: "/transport" },
                { label: "Bus Routes", link: "/busRoute" },
            ]
        },

        { label: "Special Education", link: "/specialEdu" },
        { label: "Bonding With Parents", link: "/bondingwithparents" },
        // { label: "Career Counselling", link: "/careerCounselling" },
        { label: "Meal Menu", link: "https://webapi.entab.info/api/image/LVISGURGAON/public/pdf/School-Menu.pdf" },
        { label: "CBSE Results", link: "/CBSEResult" },
        { label: "Transfer Certificate", link: "/tc" },
    ]
    return (
        <>
            <Header />
            <Breadcrumb breadImage="https://webapi.entab.info/api/image/LVISGURGAON/public/Images/apply.jpg" />
            <Menu MenuItem={homeMenu} />
            <div className="padding-blk inner-page">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <PageTitle pageTitle="Wall of Fame Section" breadEnd="Wall of Fame Section" breadMid="Wall of Fame Section" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 p-4">
                            <ul className='admission-list'>
                                <li><Link to="/CBSEResult">CBSE Result - Grades X and XII</Link></li>
                                <li><Link to="/olympiads">Olympiad Result</Link></li>
                                <li><Link to="/schoolBadgeHolder">Scholar Badge Holders</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
            <Footer />
        </>
    )
}
export default WallOfFame